import { Component, Output, Input, EventEmitter, OnInit, HostListener } from '@angular/core';
import { IxellAPIService, Reference, SearchResponseVariants, Variants } from '../../tools/api.service';
import { Sort } from '@angular/material/sort';
import { SearchCrit } from 'src/app/entities/searchCrit';
import { HeaderService } from 'src/app/tools/header.service';
import { ColonneSort } from '../../entities/ColonneSort';
import { SearchResultMixitCloud } from '../../entities/searchResultMixitCloud';
import { StorageService } from '../../tools/storage.service';
import { SearchCritMixitCloud } from '../../entities/searchCritMixitCloud';

@Component({
    selector: 'variantes',
    templateUrl: './variantes.component.html',
    styleUrls: ['./variantes.component.scss']
})

export class VariantsComponent implements OnInit {
    @Input() country: string;
    @Input() langue: string;
    @Input() variantes: SearchResponseVariants;
    @Input() infoVariantes: string;
    @Input() searchCrit: SearchCritMixitCloud;
    @Output() resultFormule = new EventEmitter<SearchResultMixitCloud>();
    @Output() outputLangue = new EventEmitter();

    listIconVariantSuffix: string[] = ["b", "c", "d", "f", "g", "l", "r", "y",];

    private searchSub: any;

    constructor(private headerService: HeaderService, private apiService: IxellAPIService, private storage: StorageService) { }

    @HostListener('window:popstate', ['$event'])
    onPopState(event: any) {
        this.headerService.changeBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnInit
     */
    ngOnInit(): void {
        window.onpopstate = function () {
        };

        if (this.variantes.variants.length == 1)
            setTimeout(() => { this.SelectFormule(this.variantes.variants[0], this.variantes.marketColorId); }, 200);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectFormule
     * @param variante
     * @param colorId
     */
    SelectFormule(variante: Variants, colorId: string) {
        this.outputLangue.emit();

        //document.getElementById("errorlbl").style.visibility = "hidden";
        if (!variante.number) {
            variante.number = "";
        }
        this.openLoader();
        this.searchSub = this.apiService.searchFormuleMixitCloud(colorId, variante.number, this.country, this.langue, variante.imitations[0].productId).subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);
            let res: SearchResultMixitCloud = new SearchResultMixitCloud();
            res.crit = this.searchCrit;
            res.formule = data;
            res.variante = variante;
            if (data != null) {
                this.resultFormule.emit(res);
            }

            if (this.searchSub != null) this.searchSub.unsubscribe();
            this.closeLoader();
        },
        error => {
            console.log(error);
            if (this.searchSub != null) this.searchSub.unsubscribe();
            this.closeLoader();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnDestroy
     */
    ngOnDestroy(): void {
        if (this.searchSub != null) this.searchSub.unsubscribe();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openLoader
     */
    openLoader() {
        let modal = document.getElementById("loadingModal");
        modal.style.display = "flex";
        if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeLoader
     */
    closeLoader() {
        let modal = document.getElementById("loadingModal");
        modal.style.display = "none";
    }
}
